import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import MsalContract from './contracts/msal.contract';
import MsalService from './services/msal.service';

const AppMsal = ({ children }: { children?: React.ReactNode }) => {
    const [msalInstance, setMsalInstance] = useState<MsalContract | undefined>(undefined);

    useEffect(() => {
        (async () => {
            const msal = await MsalService.getInstance;

            setMsalInstance(msal);
        })();
    }, []);

    const signInLoading = () => {
        return <Typography>Please wait. We are trying to sign you in.</Typography>;
    };

    if (!msalInstance) {
        return <>{signInLoading()}</>;
    }

    return (
        <MsalProvider instance={msalInstance.PCA}>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={msalInstance.AuthRequest} loadingComponent={signInLoading} errorComponent={signInLoading}>
                <BrowserRouter>{children}</BrowserRouter>
            </MsalAuthenticationTemplate>
        </MsalProvider>
    );
};

export default AppMsal;
